export default "__VITE_ASSET__8c22074e__"